<template>
  <div class="author-container">
    <v-row justify="center">
      <v-col cols="12" class="text-center">
        <div
          style="font-size: 32px; font-weight: 400; color: rgba(51, 51, 51, 1);"
        >
          {{ $i18n.t("author.Choose the version that is suitable for you") }}
        </div>
        <div
          style="
            font-size: 20px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          "
        >
          {{
            $i18n.t(
              "author.We also offer free versions for more people to try out our services"
            )
          }}
        </div>
      </v-col>
    </v-row>
    <v-row
      justify="space-between"
      align="center"
      style="text-align: center; padding: 0 !important;"
    >
      <v-col cols="2" v-for="(item, index) in cards" :key="index">
        <div
          :class="[
            'd-flex',
            'flex-column',
            'justify-space-between',
            'align-center',
            { start: index === 0 },
            { center: index !== 0 && index !== 4 },
            { end: index === 4 },
          ]"
          style="
            height: 320px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            border-radius: 2px;
            max-width: 220px;
          "
        >
          <div class="mt-2">
            <h1>{{ $i18n.t(`author.${item.title}`) }}</h1>
            <h4 class="mx-2 mt-2 text-center">
              {{ $i18n.t(`author.${item.description}`) }}
            </h4>
          </div>
          <div style="width: 100%;" class="d-flex flex-column align-center">
            <div v-if="index !== 4 && index !== 0" class="lifelong">
              ￥{{ item.lifelong }}/{{ $i18n.t("author.all life") }}
            </div>
            <div v-if="index !== 4" style="color: #5977f6;" class="my-2">
              <span style="font-size: 32px;">￥{{ item.year }}</span
              >/{{ $i18n.t("order.year") }}
            </div>
            <div
              v-if="index === 4"
              style="color: #5977f6; margin-bottom: 10px;"
            >
              <span style="font-size: 20px;">{{
                $i18n.t(`author.${item.enterprise}`)
              }}</span>
            </div>
            <v-btn
              width="90%"
              dark
              class="mb-2"
              color="#5977F6"
              @click="buy(item)"
            >
              {{ $i18n.t(`author.${item.label}`) }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <div class="text-center my-9">
      <h1 style="font-size: 32px;">
        {{ $i18n.t("author.Feature comparison between versions") }}
      </h1>
    </div>
    <div class="table-wrapper d-flex">
      <div
        class="table-left"
        style="width: 78px; border-right: 1px solid #d6ddfa;"
      >
        <div class="left-1" style="width: 78px; background: #d6ddfa;">
          <div style="height: 64px; width: 100%;"></div>
        </div>
        <div
          class="left-2 all-center"
          style="height: 256px; width: 78px; border-bottom: 1px solid #d6ddfa;"
        >
          <div
            :class="[{ labelCenter: $i18n.locale === 'en' }]"
            style="width: 20px; height: 100px; text-align: center;"
          >
            {{ $i18n.t("author.Basic") }}
          </div>
        </div>
        <div
          class="left-2 all-center"
          style="height: 128px; width: 78px; border-bottom: 1px solid #d6ddfa;"
        >
          <div
            :class="[{ labelCenter: $i18n.locale === 'en' }]"
            style="width: 20px; height: 100px; text-align: center;"
          >
            {{ $i18n.t("author.Advanced") }}
          </div>
        </div>
        <div class="left-2 all-center" style="height: 192px; width: 78px;">
          <div
            :class="[{ labelCenter: $i18n.locale === 'en' }]"
            style="width: 20px; height: 100px; text-align: center;"
          >
            {{ $i18n.t("author.Service") }}
          </div>
        </div>
      </div>

      <div class="table-right" style="width: calc(100% - 78px);">
        <div
          class="right-1 d-flex"
          style="width: 100%; height: 64px; background: #d6ddfa;"
        >
          <div
            style="
              width: 200px;
              height: 100%;
              border-right: 1px solid #d6ddfa;
              border-bottom: 1px solid #d6ddfa;
            "
          ></div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="item in descriptions.first"
          >
            {{ $i18n.t(`author.${item}`) }}
          </div>
        </div>

        <div class="right-2 d-flex" style="width: 100%; height: 64px;">
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Data review") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="item in descriptions.sec"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
        <div
          class="right-2 d-flex"
          style="width: 100%; height: 64px; background: #f6f8ff;"
        >
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Search Function") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
          >
            {{ $i18n.t("author.Opened after data review") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="item in descriptions.thrid"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
        <div class="right-2 d-flex" style="width: 100%; height: 64px;">
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Details page views") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="(item, index) in descriptions.four"
          >
            {{ $i18n.t(`author.${item}`) }}
          </div>
        </div>
        <div
          class="right-2 d-flex"
          style="
            width: 100%;
            height: 64px;
            background: #f6f8ff;
            border-bottom: 1px solid #d6ddfa;
          "
        >
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.SDF file downloads per day") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="item in descriptions.five"
          >
            {{ $i18n.t(`author.${item}`) }}
          </div>
        </div>
        <div class="right-2 d-flex" style="width: 100%; height: 64px;">
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Customer service") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="item in descriptions.six"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
        <div
          class="right-2 d-flex"
          style="
            width: 100%;
            height: 64px;
            background: #f6f8ff;
            border-bottom: 1px solid #d6ddfa;
          "
        >
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Extension of authorization by feedback") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="(item, index) in descriptions.seven"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
        <div class="right-2 d-flex" style="width: 100%; height: 64px;">
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Invoices and contracts") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="(item, index) in descriptions.eight"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
        <div
          class="right-2 d-flex"
          style="width: 100%; height: 64px; background: #f6f8ff;"
        >
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Technical support") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="(item, index) in descriptions.nine"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
        <div class="right-2 d-flex" style="width: 100%; height: 64px;">
          <div
            class="all-center"
            style="width: 200px; height: 100%; border-right: 1px solid #d6ddfa;"
          >
            {{ $i18n.t("author.Teleservice training") }}
          </div>
          <div
            class="all-center"
            style="width: calc(20% - 40px); height: 100%;"
            v-for="(item, index) in descriptions.ten"
          >
            <v-icon v-if="item" dark color="#00B76C"
              >mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else color="#D6D6D6" dark>mdi-close-circle</v-icon>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="payLoading" width="400">
      <v-card>
        <div></div>
        <div
          class="d-flex flex-column justify-space-around align-center text-center"
          style="height: 400px;"
        >
          <h1
            style="font-size: 24px; font-weight: 500; color: #333333;"
            v-if="isQuering"
          >
            {{
              $i18n.t(
                "author.Please do not close the current page, querying payment status"
              )
            }}
          </h1>
          <v-progress-circular
            v-if="isQuering"
            :size="100"
            color="#5977F6"
            indeterminate
          />
          <h1
            style="font-size: 24px; font-weight: 500; color: #333333;"
            v-if="!isQuering"
          >
            {{
              $i18n.t(
                "author.Payment is successful, please go to Personal Center => Order Management Page to view order details"
              )
            }}
          </h1>
          <div v-if="!isQuering">
            <v-icon color="#5977F6" size="100">
              mdi-checkbox-marked-circle
            </v-icon>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="428">
      <v-card>
        <v-card-title class="headline all-center" primary-title>
          {{ $i18n.t("author.Package purchase") }}
        </v-card-title>

        <v-card-text>
          <div class="all-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div
                  class="all-center"
                  v-on="on"
                  style="
                    height: 30px;
                    background: rgba(89, 246, 119, 0.22);
                    border-radius: 21px;
                    padding: 5px;
                    color: #00b76c;
                  "
                >
                  <v-icon color="#59F677">info</v-icon>
                  {{ $i18n.t("author.Purchase instructions") }}
                </div>
              </template>
              <span style="display: inline-block !important; max-width: 300px;">
                {{ $i18n.t("author.This product is a software product") }}
              </span>
            </v-tooltip>
          </div>
          <div class="mt-2">
            {{ $i18n.t("author.Package selection") }}：
            {{ $i18n.t(`author.${type}`) }}
          </div>
          <div class="d-flex justify-start align-center">
            <div class="mb-2 mr-1">
              {{ $i18n.t("author.Purchase duration") }}：
            </div>
            <v-radio-group
              v-model="years"
              row
              :mandatory="false"
              @change="changeYears"
            >
              <v-radio label="" value="numbers" />
              <div
                class="all-center"
                style="margin-left: -20px; border: 1px solid #999;"
              >
                <div
                  class="all-center"
                  style="cursor: pointer;"
                  @click="changeBody(-1)"
                >
                  <v-icon size="30">mdi-minus</v-icon>
                </div>
                <div
                  style="
                    padding: 4px 10px;
                    border-right: 1px solid #999;
                    border-left: 1px solid #999;
                  "
                >
                  {{ orderMsg.body }}
                </div>
                <div
                  class="all-center"
                  style="cursor: pointer;"
                  @click="changeBody(1)"
                >
                  <v-icon size="30">mdi-plus</v-icon>
                </div>
              </div>
              <div class="all-center ml-1 mr-4">
                {{ $i18n.t("order.year") }}
              </div>
              <v-radio :label="$i18n.t('author.all life')" value="all" />
            </v-radio-group>
          </div>
          <div class="d-flex align-center my-2">
            <div class="mr-2">{{ $i18n.t("author.payment method") }}：</div>
            <img src="../assets/alipay.png" alt="" />
          </div>
          <div class="mt-6 d-flex align-center">
            {{ $i18n.t("author.Amounts payable") }}：
            <div class="ml-1">
              <h1>￥{{ orderMsg.totalAmount }}</h1>
            </div>
          </div>
        </v-card-text>

        <v-divider />
        <div class="d-flex align-center ml-2">
          <div class="ma-0 pa-0 mb-6" style="height: 30px;">
            <v-checkbox
              v-model="agree"
              style="font-size: 14px;"
              color="#3f57bb"
              :label="$i18n.t('author.read and agree')"
            />
          </div>
          <div
            class="text-left ma-0 pa-0 pl-3"
            style="
              height: 30px;
              cursor: pointer;
              color: #3f57bb;
              font-size: 14px;
              margin-top: 15px !important;
            "
            @click="toPurchase"
          >
            {{ $i18n.t("author.Purchase agreement") }}
          </div>
        </div>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            color="#3f57bb"
            dark
            width="100%"
            height="48px"
            @click="ConfirmPayment"
          >
            {{ $i18n.t("author.Confirm payment") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  name: "Author",
  data() {
    return {
      payLoading: false,
      agree: false,
      dialog: false,
      isQuering: true, //正在查询中
      years: "numbers", // 判断是一年版还是终身
      year: 0, // 一年的价格
      lifelong: 0, // 终身的价格
      type: "Personal",
      orderMsg: {
        //给后端传递的数据
        totalAmount: "",
        subject: "",
        body: "",
      },
      descriptions: {
        first: ["Free", "Education", "Personal", "Professional", "Enterprise"],
        sec: [true, false, false, false, false],
        thrid: [true, true, true, true],
        four: ["60次", "50次/日", "50次/日", "15000次/年", "15000次/年"],
        five: ["10", "50", "50", "Unlimited", "Unlimited"],
        six: [false, true, true, true, true],
        seven: [true, true, true, true, true],
        eight: [false, true, true, true, true],
        nine: [false, true, true, true, true],
        ten: [false, false, false, false, true],
      },
      cards: [
        {
          title: "Free",
          subject: "free",
          description: "For new registered users",
          lifelong: 2598,
          year: "0",
          label: "Apply",
          enterprise: "",
        },
        {
          title: "Education",
          subject: "edu",
          description:
            "Users who registered with the education mailbox are free for the first three months, and the feedback can extend the authorization",
          lifelong: 1998,
          year: 698,
          label: "Apply",
          enterprise: "",
        },
        {
          title: "Personal",
          subject: "personal",
          description: "For individual users",
          lifelong: 1998,
          year: 698,
          label: "Buy",
          enterprise: "",
        },
        {
          title: "Professional",
          subject: "professional",
          description: "Suitable for corporate and scientific users",
          lifelong: 2598,
          year: 998,
          label: "Buy",
          enterprise: "",
        },
        {
          title: "Enterprise",
          subject: "company",
          description:
            "Applicable to enterprises and research institutions of different sizes",
          lifelong: "",
          year: "",
          enterprise: "Purchase a minimum of 10 business accounts",
          label: "Service",
        },
      ],
    };
  },
  mounted() {
    if (window.localStorage.getItem("accessToken")) {
      this.cards[1].label = "Buy";
    } else {
      this.cards[1].label = "Apply";
    }
  },
  methods: {
    ...mapActions(["aliPay", "aliQueryAnswer", "refreshToken"]),
    ...mapMutations(["SET_SHOW_SIGNUP", "SET_SNACK_INFO"]),
    buy(item) {
      this.agree = false;
      if (window.localStorage.getItem("accessToken")) {
        //如果已经登录
        if (item.subject === "free") {
          this.SET_SNACK_INFO({
            status: true,
            color: "info",
            msg: "You are already free",
            timeout: 2000,
          });
        } else if (item.subject === "company") {
          this.SET_SNACK_INFO({
            status: true,
            color: "info",
            msg: "Please contact customer service, TEL: 0551-62886576",
            timeout: 5000,
          });
        } else {
          this.years = "numbers";
          this.year = item.year;
          this.lifelong = item.lifelong;
          this.type = item.title;

          this.orderMsg.totalAmount = item.year;
          this.orderMsg.subject = item.subject;
          this.orderMsg.body = 1;

          this.dialog = true;
        }
      } else {
        this.SET_SHOW_SIGNUP(true);
      }
    },
    async ConfirmPayment() {
      if (!this.agree) {
        this.SET_SNACK_INFO({
          status: true,
          color: "info",
          msg: "Please check agree to purchase agreement",
          timeout: 2000,
        });
        return;
      }
      this.dialog = false;
      this.isQuering = true;
      if (this.years === "all") {
        this.orderMsg.body = 60;
      }
      let res = await this.aliPay(this.orderMsg);
      if (res.data.code === 200) {
        this.payLoading = true;

        window.open(res.data.data.url);
        let timer = 0;
        let PollQuery = setInterval(async () => {
          let answer = await this.aliQueryAnswer({
            outTradeNo: res.data.data.outTradeNo,
          });

          if (answer.data.code === 500) {
            clearInterval(PollQuery);
            return;
          }
          timer = timer + 1;
          if (answer.data.data === true || timer >= 60) {
            if (answer.data.data === true) {
              this.isQuering = false;
              this.refreshToken({
                refreshToken: JSON.parse(
                  window.localStorage.getItem("refreshToken")
                ),
              }).then((res) => {
                window.localStorage.setItem(
                  "accessToken",
                  JSON.stringify(res.data.message)
                );
              });
            }
            clearInterval(PollQuery);
          }
        }, 5000);
      }
    },
    changeBody(num) {
      //改变数量
      if (this.years === "numbers") {
        this.orderMsg.body = this.orderMsg.body + num;
        if (this.orderMsg.body <= 1) {
          this.orderMsg.body = 1;
        }
        this.orderMsg.totalAmount = this.orderMsg.body * this.year;
      }
    },
    changeYears(value) {
      // 年 <=> 终身
      this.orderMsg.body = 1;
      if (value === "all") {
        this.orderMsg.totalAmount = this.lifelong;
      } else {
        this.orderMsg.totalAmount = this.year;
      }
    },
    toPurchase() {
      let serviceMSg = {};
      if (this.years === "all") {
        // 终身   一年
        serviceMSg.price = this.lifelong;
        serviceMSg.time = 1;
        serviceMSg.auth = 60;
        serviceMSg.subject = this.type;
      } else {
        serviceMSg.price = this.year;
        serviceMSg.time = this.orderMsg.body - 0;
        serviceMSg.auth = this.orderMsg.body - 0;
        serviceMSg.subject = this.type;
      }
      window.localStorage.setItem("serviceMsg", JSON.stringify(serviceMSg));
      window.open("#/purchaseAgreement");
    },
  },
};
</script>

<style lang="scss">
.author-container {
  width: 100%;
  min-width: 1264px;
  margin: 0 100px;
  margin-bottom: 100px;
  background: rgba(248, 249, 251, 1);
  font-family: PingFangSC-Regular, PingFang SC;

  .start {
    margin-right: auto;
  }
  .center {
    margin: 0 auto;
  }
  .end {
    margin-left: auto;
  }
  h1 {
    font-size: 24px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }

  h4 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(151, 151, 152, 1);
  }

  .lifelong {
    background: rgba(89, 246, 119, 0.22);
    border-radius: 13px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 183, 108, 1);
    width: 121px;
  }

  .table-wrapper {
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(214, 221, 250, 1);
  }

  .labelCenter {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
}
</style>
